import CampoTexto from '@/components/Formulario/CampoTexto';
import Grid, { GridItem } from '@/components/layout/Grid';
import SeletorEscopoAppliances, {
  EscopoAppliance,
} from '@/components/Formulario/SeletorEscopoAppliances';

export const FormGrupoUsuario = ({
  value,
  onChange,
  fieldErrors,
}: {
  value: any;
  onChange: any;
  fieldErrors: any;
}) => {
  const scope: EscopoAppliance = value?.appliance_scope ?? 'all';
  const selectedIds: number[] = value?.appliance_ids ?? [];

  return (
    <Grid>
      <GridItem sm={12}>
        <CampoTexto
          value={value?.nome ?? ''}
          onChange={v => onChange({ ...value, nome: v })}
          label="Nome"
          error={fieldErrors?.nome}
        />
      </GridItem>
      <GridItem sm={12}>
        <CampoTexto
          value={value?.descricao_curta ?? ''}
          onChange={v => onChange({ ...value, descricao_curta: v })}
          label="Descrição curta"
          error={fieldErrors?.descricao_curta}
          tooltipPosition="left"
          tooltipText="✨Esta descrição ajudará os agentes de IA a entenderem melhor o setor em que estão atuando."
          placeholder='Ex: "Atendimento ao cliente"'
        />
      </GridItem>

      <GridItem sm={12}>
        <SeletorEscopoAppliances
          label="Appliances visíveis para o grupo"
          scope={scope}
          onScopeChange={s =>
            onChange({
              ...value,
              appliance_scope: s,
              appliance_ids: s === 'specific' ? selectedIds : [],
            })
          }
          selectedIds={selectedIds}
          onSelectedIdsChange={ids => onChange({ ...value, appliance_ids: ids })}
        />
      </GridItem>
    </Grid>
  );
};
